export const isAiffFile = (file: File) =>
  file.type === "audio/aiff" || file.type === "audio/x-aiff";
